<div #carouselContainer class="position-relative carousel-container hover-fade-in fade-out fade-children" data-test="watch-carousel-container">
    <div class="handle-container handle-left-container position-absolute bottom h-100 left d-flex justify-content-end hover-fade-in fade-out">
        <span
          *ngIf="showScrollControls$ | async as controls"
          floAnalytics
          name="Navigate Carousel Left"
          tagName="Button"
          data-test="left-scroll-control"
          [ngClass]="{ 'd-md-flex': controls.showLeft }"
          class="d-none handle bg-white color-900 justify-content-center bottom position-absolute"
          (click)="scrollClick$.next(-controls.clientWidth)"
        >
          <flo-svg-icon class="svg-vertical-align-middle align-self-center d-flex" icon="icon-chevron-left" width="1em"></flo-svg-icon>
        </span>
      </div>
  <div #scrollContainer class="d-flex flex-row content-container position-relative px-md-4 px-3 px-lg-0 py-0" data-test="watch-carousel-scroll">
    <ng-content></ng-content>
  </div>
  <div class="handle-container handle-right-container position-absolute bottom right h-100 hover-fade-in fade-out">
      <span
        *ngIf="showScrollControls$ | async as controls"
        floAnalytics
        name="Navigate Carousel Right"
        tagName="Button"
        data-test="right-scroll-control"
        [ngClass]="{ 'd-md-flex': controls.showRight }"
        class="d-none handle justify-content-center bottom bg-white color-900 position-absolute"
        (click)="scrollClick$.next(controls.clientWidth)"
      >
        <flo-svg-icon class="svg-vertical-align-middle align-self-center d-flex" icon="icon-chevron-right" width="1em"></flo-svg-icon>
      </span>
    </div>
</div>
